"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationResponseReply = exports.SendMessageRequest = exports.DomainScopes = exports.DeliveryExceptionsReasonsPlural = exports.DeliveryExceptionsReasons = exports.AlertIdData = exports.AlertEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["UnreadAlertsCountEvent"] = "UnreadAlertsCountEvent";
    EventTypes["PushOpenedEvent"] = "PushOpenedEvent";
    EventTypes["PushSentEvent"] = "PushSentEvent";
})(EventTypes || (exports.EventTypes = EventTypes = {}));
var AlertEventActions;
(function (AlertEventActions) {
    AlertEventActions["UnreadAlertCount"] = "UnreadAlertCount";
    AlertEventActions["PushOpened"] = "PushOpened";
    AlertEventActions["PushSent"] = "PushSent";
})(AlertEventActions || (exports.AlertEventActions = AlertEventActions = {}));
exports.AlertIdData = [
    {
        alertId: "100001",
        linkLabel: "i18n.notifications.ctaLinkLabels.trackMyDelivery",
        url: "my-orders?lnksrc=deliveryRescheduled",
    },
    {
        alertId: "100021",
        linkLabel: "i18n.notifications.ctaLinkLabels.trackMyDelivery",
        url: "my-orders?lnksrc=truckNotYetDeparted",
    },
    {
        alertId: "100022",
        linkLabel: "i18n.notifications.ctaLinkLabels.trackMyDelivery",
        url: "my-orders?lnksrc=truckDepartedLate",
    },
    {
        alertId: "100023",
        linkLabel: "i18n.notifications.ctaLinkLabels.viewDetails",
        detailLinkLabel: "i18n.notifications.ctaLinkLabels.viewMyOrder",
        url: "my-orders?lnksrc=deliveryExceptions",
        pushRoute: "/notifications/notification-details",
        originType: "originType=push-alerts-deliveryIssues",
    },
    {
        alertId: "100024",
        linkLabel: "i18n.notifications.ctaLinkLabels.createYourOrder",
        url: "lists?lnksrc=cutOffToPlaceOrder",
        pushRoute: "/lists",
        originType: "originType=push-alerts-orderCutoff",
    },
    {
        alertId: "100025",
        linkLabel: "i18n.notifications.ctaLinkLabels.reviewOrder",
        url: "my-orders?lnksrc=cutOffToSubmitOrder",
        pushRoute: "/my-orders",
        originType: "originType=push-alerts-inProgressOrderCutoff",
    },
    {
        alertId: "100026",
        linkLabel: "i18n.notifications.ctaLinkLabels.trackMyDelivery",
        url: "my-orders?lnksrc=deliveryHeadsUp",
        pushRoute: "/my-orders",
        originType: "originType=push-alerts-delivery30Min",
    },
    {
        alertId: "100027",
        linkLabel: "i18n.notifications.ctaLinkLabels.makeAPayment",
        url: "payments/make-payment?lnksrc=paymentDueThisWeek",
        pushRoute: "/payments/make-payment",
        originType: "originType=push-alerts-paymentDueThisWeek",
    },
    {
        alertId: "100028",
        linkLabel: "i18n.notifications.ctaLinkLabels.makeAPayment",
        url: "payments/make-payment?lnksrc=paymentDueToday",
        pushRoute: "/payments/make-payment",
        originType: "originType=push-alerts-paymentDueToday",
    },
    {
        alertId: "100029",
        linkLabel: "i18n.notifications.ctaLinkLabels.makeAPayment",
        url: "payments/make-payment?status=Partially_Paid,Overdue&lnksrc=paymentPastDue",
        pushRoute: "/payments/make-payment?status=Partially_Paid,Overdue",
        originType: "originType=push-alerts-paymentPastDue",
    },
    {
        alertId: "100032",
        pushRoute: "/notifications/note-details",
        originType: "originType=push-alerts-tmNotes",
    },
    {
        alertId: "100044",
        linkLabel: "i18n.notifications.ctaLinkLabels.viewDetails",
        pushRoute: "/my-orders",
        originType: "originType=push-alerts-directShipAlert",
    },
    {
        alertId: "100045",
        linkLabel: "i18n.notifications.ctaLinkLabels.viewDetails",
        url: "my-orders?lnksrc=directStandardDelivery",
        pushRoute: "/my-orders",
        originType: "originType=push-alerts-directStandardDelivery",
    },
    {
        alertId: "100046",
        linkLabel: "i18n.notifications.ctaLinkLabels.viewDetails",
        url: "my-orders?lnksrc=directOrderExceptions",
        pushRoute: "/my-orders",
        originType: "originType=push-alerts-directOrderExceptions",
    },
    {
        alertId: "100047",
        linkLabel: "i18n.notifications.ctaLinkLabels.viewDetails",
        url: "my-orders?lnksrc=directDeliveryExceptions",
        pushRoute: "/my-orders",
        originType: "originType=push-alerts-directDeliveryExceptions",
    },
    {
        alertId: "100051",
        linkLabel: "i18n.notifications.ctaLinkLabels.viewDetails",
        url: "notifications/notification-details/",
        pushRoute: "/notifications/notification-details",
        originType: "originType=push-alerts-whscutsOrderUnavailable",
    },
];
var DeliveryExceptionsReasons;
(function (DeliveryExceptionsReasons) {
    DeliveryExceptionsReasons["01"] = "i18n.notifications.deliveryExceptionReasons.01";
    DeliveryExceptionsReasons["03"] = "i18n.notifications.deliveryExceptionReasons.03";
    DeliveryExceptionsReasons["04"] = "i18n.notifications.deliveryExceptionReasons.04";
    DeliveryExceptionsReasons["08"] = "i18n.notifications.deliveryExceptionReasons.08";
})(DeliveryExceptionsReasons || (exports.DeliveryExceptionsReasons = DeliveryExceptionsReasons = {}));
var DeliveryExceptionsReasonsPlural;
(function (DeliveryExceptionsReasonsPlural) {
    DeliveryExceptionsReasonsPlural["01"] = "i18n.notifications.deliveryExceptionReasonsPlural.01";
    DeliveryExceptionsReasonsPlural["03"] = "i18n.notifications.deliveryExceptionReasonsPlural.03";
    DeliveryExceptionsReasonsPlural["04"] = "i18n.notifications.deliveryExceptionReasonsPlural.04";
    DeliveryExceptionsReasonsPlural["08"] = "i18n.notifications.deliveryExceptionReasonsPlural.08";
})(DeliveryExceptionsReasonsPlural || (exports.DeliveryExceptionsReasonsPlural = DeliveryExceptionsReasonsPlural = {}));
var DomainScopes;
(function (DomainScopes) {
    DomainScopes["MyUnreadAlertsCount"] = "MyUnreadAlertsCount";
})(DomainScopes || (exports.DomainScopes = DomainScopes = {}));
class SendMessageRequest {
    constructor(deviceToken, title, message) {
        this.deviceToken = deviceToken;
        this.title = title;
        this.message = message;
    }
}
exports.SendMessageRequest = SendMessageRequest;
class NotificationResponseReply {
}
exports.NotificationResponseReply = NotificationResponseReply;
